// extracted by mini-css-extract-plugin
export default {"descriptionToggleButton":"N8-z"};